import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, { fix: true }, {
    default: _withCtx(() => [
      _createVNode(_component_miezz_form, {
        modelValue: _ctx.detail,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail) = $event)),
        isDetail: true
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'Files')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_upload, {
                    modelValue: _ctx.detail.Data.Files,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.Data.Files) = $event)),
                    prop: "File",
                    preview: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'Link')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:void",
                    class: _normalizeClass(`field-link ${
              _ctx.detail.Data.LinkLabel || _ctx.detail.Data.Link ? '' : 'empty'
            }`),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLinkClick && _ctx.handleLinkClick(...args)))
                  }, _toDisplayString(_ctx.detail.Data?.LinkLabel ?? _ctx.detail.Data.Link ?? "暂无数据"), 3)
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.buttons,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buttons) = $event)),
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"])
    ]),
    _: 1
  }))
}